module.exports = __webpack_public_path__ + "img/marker.735320f3.png";